import { readableTextColor as baseReadableTextColor } from '@atlassian/color-picker/utils/readable-text-color';

export const readableTextColor = (color: string): string => {
	return baseReadableTextColor(color, '@atlassian/hub-app-shell');
};
